<template>
	<div style='background:white;' class='' v-loading='loading'>


		<div class='gPageBorder' id='pdthead'>
			<div class='pdthdfr'>
				<el-row>
					<el-col :span='12'>
						<div class='gwordels' style="width:100%;height:44px;font-size:24px;">
							{{key_detail.secretName}}
						</div>
					</el-col>
				</el-row>
			</div>
		</div>

		<div class='gPageBorder gTopMg'>


			<el-row>
				<el-col :span='20'>
					<div class='gSgLeftBtn'>
						<el-button @click="open_add" type='primary' class=''>
							{{$t('terminal.list.add_btn')}}
						</el-button>
						<el-button :disabled="delete_device_list.length == 0" @click="delete_device">
							{{$t('app_mulDel')}}</el-button>




						<el-button @click="getList" type='text' class=''>{{$t('lin_global.shuaxin')}}</el-button>
					</div>

				</el-col>



				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_number')" v-model='select_form.terminalNo'
							@keyup.enter.native='getList' icon="search" :on-icon-click="getList"></el-input>
					</div>
				</el-col>
			</el-row>



			<el-table class='' v-loading="loading" :data="tableData" @selection-change="handleDevice" id="tp" border
				style="margin-bottom: 20px;margin-top: 20px;">
				<el-table-column type="selection" width="55">
				</el-table-column>

				<el-table-column prop="terminalNo" align="center" header-align="center" :label="$t('app_serialnumber')">

				</el-table-column>
				<el-table-column prop="status" align="center" header-align="center" :label="$t('app_status')">
					<template slot-scope="scope">
						<label for="" v-if="scope.row.status === 0" > 待更新 </label>
						<label for="" v-if="scope.row.status === 1" > 已推送 </label>
						<label for="" v-if="scope.row.status === 2" > 已更新 </label>
						<label for="" v-if="scope.row.status === 3" > 密钥存在 </label>
						<label for="" v-if="scope.row.status === 4" > 失败 </label>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" align="center" header-align="center" :label="$t('app_createTime')">

				</el-table-column>

				<el-table-column header-align="center" align="center" :label="$t('lin_global.ope')" width="150">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
							<el-button type='text' @click="deleteRow(scope.row.id)"><i class="fa fa-trash"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style='gPgDiv'>

				<el-pagination class='gPg' @current-change="pageChange" @size-change="pageSize" :current-page="page"
					:page-sizes='$gRows' :page-size="$gRow" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>

			</div>
		</div>

		<el-dialog class='gDia' :title="$t('app_adddv')" v-model="pushdev" @close='handleClose' size=''>
			<div v-loading='loading' id='' class='gBorder'>
				<el-row style=''>
					<el-col :span="12">

						<el-button type='primary' :disabled="push_list.length == 0" @click='bcPush' class='gSgLeftBtn'
							style=''>{{$t('app_pushsldev')}}</el-button>
						<!-- <el-button type='primary' class='' @click='pushAll' style=''>{{$t('app_pushAll')}}</el-button>
						<el-button type='primary' class='' @click='fileImport' style=''>{{$t('app_fileImport')}}
						</el-button> -->

					</el-col>
					<el-col :offset="0" :span="4">
						<div class='gCtrl'>
							<el-select @change='get_device_list' clearable v-model="form.cmtStatus"
								:placeholder="$t('app_status')">
								<el-option v-for="item in cmtStatusArr" :key="item.vl" :label="item.lb"
									:value="item.vl">
								</el-option>
							</el-select>
						</div>
					</el-col>

					<el-col v-show='true' :offset="0" :span="4">
						<div class='gCtrl'>
							<MechanismSelector style='width:100%;' :data="mechanismData_2"></MechanismSelector>
						</div>
					</el-col>
					<el-col v-show='true' :span="4">
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_terNo')" icon='search' :on-icon-click='get_device_list'
								@keyup.enter.native='get_device_list' v-model='form.terminalNo'></el-input>
						</div>
					</el-col>
				</el-row>

				<el-table class='gTopMg' ref="multipleTable" id='dpTable' :data="tableData_2" border
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" align='center' width="55">
					</el-table-column>
					<el-table-column prop="terminalNo" align='center' :label="$t('app_terNo')" width="210">
					</el-table-column>
					<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="210">
					</el-table-column>
					<el-table-column prop="terminalStatus" align='center' :label="$t('app_status')" width="210">
						<template slot-scope="scope">
							<span>
								<tagc :tagobj="{type: 'terSt', vl: scope.row.terminalStatus}"></tagc>
							</span>
						</template>
					</el-table-column>
					<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width="210">
					</el-table-column>

					<el-table-column prop="operate" :label="$t('app_operate')" align='center' width='106'>
						<template slot-scope='scope'>


							<el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
								<el-button @click='pushed(scope.row)' type=text><i class="fa fa-upload" style=""></i>
								</el-button>
							</el-tooltip>

						</template>
					</el-table-column>
				</el-table>

				<div class="gPgDiv">

					<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized"
						:current-page="page_2" :page-sizes='[20,100]' :page-size="ttpage"
						layout="total, sizes, prev, pager, next, jumper" :total="total_2">
					</el-pagination>
				</div>
			</div>
		</el-dialog>


	</div>
</template>

<style>
	.dtcmgp {
		width: 100%;
		overflow: visible;
	}

	.dtcmgp label {
		display: inline-block;
		overflow: visible;
		text-overflow: initial;
	}

	#pdthead {
		padding: 0 24px 0px 24px;
	}

	.pdthdfr {
		height: 50px;
	}

	.pdthdfr:nth-child(1) {
		line-height: 50px;
		margin-top: 11px;
		margin-bottom: 11px;
	}

	.pdthdfr:nth-child(1) label {
		/* font-size:24px; */
		color: #48576A;
	}

	.taskrow {
		border: 1px solid rgb(213, 228, 254);
		height: 60px;
		margin-bottom: 20px;
		border-radius: 5px;
		overflow: hidden;
		font-size: 13px;
	}

	.pdts1 {
		border-right: 1px solid rgb(232, 236, 241);
		height: 80%;
		position: relative;
		top: 10%;
		line-height: 48px;
		text-align: right;
		color: #409EFF;
		padding-right: 10px;
		margin-right: 10px;
		width: calc(100% - 20px);
		font-size: 17px;
	}

	.pdts2 {
		width: 100%;
		height: 100%;
		line-height: 60px;
		overflow: hidden;
	}

	.pdts2 label {
		color: #99A9BF;
	}

	.pdts2 div {
		display: inline-block;
		float: left;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.pdts2 div:nth-child(1) {
		width: 24%;
	}

	.pdts2 div:nth-child(2) {
		width: 34%;
	}

	.pdts2 div:nth-child(3) {
		width: 21%;
		position: relative;
		overflow: none;
	}

	.pdts2 div:nth-child(4) {
		width: 21%;
	}

	.pdts3 {
		height: 100%;
		line-height: 60px;
		text-align: right;
		padding-right: 24px;
		position: relative;
		overflow: hidden;
	}

	.pdts3 label {
		color: #99A9BF;
	}


	.ptmt td {
		width: 25%;
	}

	.dt-word-main {
		color: rgb(72, 87, 106)
	}

	.dt-word-title {
		color: #99A9BF;
	}

	pre {
		white-space: pre-wrap;
		word-wrap: break-word;
		white-space: -moz-pre-wrap;
		white-space: -pre-wrap;
		white-space: -o-pre-wrap;
		word-break: break-all;
	}

	.dt-launch {
		width: 100%;
		height: 100%;
		background: none;
	}


	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.sm-avatar-uploader-icon {
		font-size: 36px;
		color: #8c939d;
		width: 72px;
		height: 72px;
		line-height: 72px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}
</style>

<script>
	import mm from 'moment'
	import axios from 'axios'
	import {
		baseurl,
		focusEvent,
		urlAssets
	} from '../../api/url'
	import tyc from '@/components/global/tyc'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import tagc from '@/components/global/tagc'
	export default {
		data() {
			var that = this
			return {
				delete_device_list: [],
				ttpage: 20,
				total_2: 0,
				page_2: 1,
				pushdev: false,
				push_list: [],
				tableData_2: [],
				mechanismData_2: {
					callback(value) {
						that.form.mechId = value
						that.get_device_list()
					}
				},
				cmtStatusArr: [{
						vl: "1",
						lb: "在线"
					},
					{
						vl: "2",
						lb: "离线"
					}, {
						vl: "0",
						lb: "新增"
					},
					{
						vl: "3",
						lb: "休眠"
					}
				],
				key_detail: {
					id: "",
					secretName: ""
				},
				select_form: {
					terminalNo: ""
				},
				form: {
					terminalNo: '',
					cmtStatus: "",
					mechId: '',

				},
				orderType: '',
				orderName: '',
				tty: '',
				mech: '',
				mech1: '',
				srchValue: '',
				delete_list: [],
				info: '',
				bindVl: '',
				config: '',
				captures: [],
				loading: 0,
				tableData: [],
				tags: [],
				page: 1,
				index: 1,
				hiss: [],
				total: 0
			}
		},
		components: {
			tyc,
			MechanismSelector,
			tagc
		},
		created() {
			this.key_detail.id = this.$route.query.kid;
			this.key_detail.secretName = this.$route.query.kName
			this.getList()
		},
		methods: {
			// 打开添加设备窗口
			open_add() {
				this.pushdev = true
				this.get_device_list()
			},
			pageSized(vl) {
				this.ttpage = vl
				this.get_device_list()
			},
			pageSelect(vl) {
				this.page_2 = vl
				this.get_device_list()
			},
			// 推送设备勾选
			handleSelectionChange(vl) {
				this.push_list = vl
			},
			// 推送选中设备
			pushed(row) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ?', this.$t('app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
					axios.post(`${baseurl}/secret/addTerminal.do`, {
						terminalNo: row.terminalNo,
						secretId: this.key_detail.id,
					}).then(res => {
						if (res.status === 200) {
							//console.log(res.data)
							this.$message.success(res.data.message)
							this.handleClose();
							this.getList();
						} else {
							this.$message.error(res.message)
						}
					})

				}, '')
			},
			// 批量推送
			bcPush() {
				let terminal_list = []
				for (var i = 0; i < this.push_list.length; i++) {
					terminal_list.push(this.push_list[i].terminalNo)
				}
				axios.post(`${baseurl}/secret/addTerminal.do`, {
					terminalNo: String(terminal_list),
					secretId: this.key_detail.id,
				}).then(res => {
					if (res.status === 200) {
						//console.log(res.data)
						this.$message.success(res.data.message)
						this.handleClose();
						this.getList();
					} else {
						this.$message.error(res.message)
					}
				})
			},
			// 关闭添加设备弹窗
			handleClose() {
				this.pushdev = false
				this.form = {
					terminalNo: '',
					cmtStatus: "",
					mechId: '',
				}
				var that = this;
				this.mechanismData_2 = {
					callback(value) {
						that.form.mechId = value
						that.get_device_list()
					}
				}
			},
			// 删除设备勾选
			handleDevice(val) {
				this.delete_device_list = val;
			},
			// 批量删除密钥设备
			delete_device() {
				let terminal_list = []
				for (var i = 0; i < this.delete_device_list.length; i++) {
					terminal_list.push(this.delete_device_list[i].id)
				}
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/secret/deletedTerminal.do`, {
						id: String(terminal_list)
					}).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data); 
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getList();

						} else {
							this.$message.error(res.data.message)
						}
					})
				})
			},
			// 删除密钥设备
			deleteRow(id) {
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/secret/deletedTerminal.do`, {
						id: id
					}).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data); 
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getList();

						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				})
			},
			// 获取设备列表
			get_device_list() {
				this.loading = true
				var mc = this.form.mechId
				var tno = this.form.terminalNo
				var tstatus = this.form.cmtStatus
				this.$getDvDevices(this.page_2, this.ttpage, mc, tno, tstatus, "", '', '','','', (res) => {
					this.loading = 0
					if (res.status === 200) {
						//console.log(res.data)
						this.tableData_2 = res.data
						this.total_2 = res.total
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			getList() {

				let add_form = {
					page: this.page,
					rows: this.$gRow,
					secretId: this.key_detail.id,
					terminalNo: this.select_form.terminalNo
				}
				this.loading = 1
				axios.post(`${baseurl}/secret/terminalList.do`, add_form).then(res => {
					//console.log("打印返回列表2");
					//console.log(res.data);
					if (res.data.status == 200) {
						this.tableData = res.data.data
						this.total = res.data.total
						this.loading = false;
					} else {
						this.loading = false;
					}

				})


			},
			// 翻页
			pageChange(vl) {
				this.page = vl
				this.getList()
			},
			// 切换每页显示个数
			pageSize(val) {
				this.$gRow = val
				this.getList()
			},






		},
	}
</script>



// WEBPACK FOOTER //
// keyManagement_detail.vue?5040db10